/** Certification tiles — same order as the original list. */
export const CERTIFICATION_TILES = [
  {
    id: 'iiqe',
    title: 'IIQE',
    metaLine: 'Insurance Intermediaries Qualifying Examination',
    teaser: 'Completed Papers I, II, and III.',
    items: ['Paper I', 'Paper II', 'Paper III'],
  },
  {
    id: 'le',
    title: 'LE',
    metaLine: 'Licensing Examination',
    teaser: 'Completed Papers I, VII, and VIII.',
    items: ['Paper I', 'Paper VII', 'Paper VIII'],
  },
  {
    id: 'pcap',
    title: 'PCAP',
    metaLine: 'Certified Associate in Python Programming',
    teaser: 'Python Institute — foundational Python programming.',
    items: ['Industry credential issued by the Python Institute; badge hosted on Credly.'],
    externalUrl: 'https://www.credly.com/badges/7db6ff85-3e8a-425c-ab89-3e82c323ab81/public_url',
    externalLabel: 'View badge on Credly',
  },
  {
    id: 'sas-associate',
    title: 'SAS Certified Associate',
    metaLine: 'Programming Fundamentals Using SAS 9.4',
    teaser: 'Entry-level SAS programming credential.',
    items: ['Validates core SAS 9.4 programming fundamentals.'],
    externalUrl: 'https://www.credly.com/badges/cc6e0f5d-2382-4613-9017-7ac52ce8636f/public_url',
    externalLabel: 'View badge on Credly',
  },
  {
    id: 'sas-specialist',
    title: 'SAS Certified Specialist',
    metaLine: 'Base Programming Using SAS 9.4',
    teaser: 'Advanced base programming credential.',
    items: ['Demonstrates proficiency in SAS 9.4 base programming.'],
    externalUrl: 'https://www.credly.com/badges/9612a01e-4f6a-490e-9883-bd6f3e391692/public_url',
    externalLabel: 'View badge on Credly',
  },
];
